var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1267.57,
    y1: 799.85,
    x2: -1267.33,
    y2: 799.85,
    gradientTransform: "translate(41524.73 226599.54) rotate(47.37) scale(153.67 -153.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#004fa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#004fa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004fa3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1268.86,
    y1: 805.06,
    x2: -1268.63,
    y2: 805.06,
    gradientTransform: "translate(-192955.56 116169.17) rotate(116.56) scale(149.88 -149.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef3e42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#9e0918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#9e0918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e0918"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1267.36,
    y1: 800.2,
    x2: -1267.13,
    y2: 800.2,
    gradientTransform: "translate(-9281.64 240750.57) rotate(59.95) scale(160.73 -160.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8cc63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00a663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#00a663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a663"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path140",
    className: "cls-3",
    d: "m23.6,58.09c-4.37,4.76-8.75,6.87-13.5,8.64h0c5.38,8,14.53,13.27,24.9,13.27h0c11.4,0,21.32-6.36,26.39-15.73h0c-9.87-3.52-16.06-10.47-20.55-18.18h0c-1.68-2.87-5.44-8.29-8.64-10.38h0c0,8.18-3.27,16.55-8.61,22.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path170",
    className: "cls-1",
    d: "m5,50c0,2.71.36,5.34,1.03,7.84h0c11.48-4.21,19.88-15.64,15.36-28.29h0c-.62-1.72-1.61-3.26-2.75-4.7h0c-8.21,5.35-13.64,14.61-13.64,25.15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path200",
    className: "cls-2",
    d: "m29.83,20.44c11.16,7.47,15.78,14.97,21.71,23.5h0c4.15,5.99,7.64,8.03,13.09,10.78h0c.24-1.54.37-3.12.37-4.72h0c0-16.57-13.43-30-30-30h0c-1.77,0-3.49.15-5.17.44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue05);
export default __webpack_public_path__ + "static/media/blue05.1ce882ac6d5085535476e02774ddb775.svg";
export { ForwardRef as ReactComponent };